// initial state
const state = () => ({
  prevPath: '',
  prevName: '',
});

// getters
const getters = {
  getPrevPath: state => {
    return state.prevPath;
  },
  getPrevName: state => {
    return state.prevName;
  },
};

// actions
const actions = {};

// mutations
const mutations = {
  setPrevRoute: (state, { path, name }) => {
    state.prevPath = path;
    state.prevName = name;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
